import React from "react";
import styles from "./style.module.scss";
import logo from "../../../../assets/images/mashie-shield-with-text-white.png";
import { Link } from "react-router-dom";
import DeprecatedBanner from "./utils/DeprecatedBanner";
import APIVersionDropdown from "./utils/APIVersionDropdown";
import SectionDropdown from "./utils/SectionDropdown";

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    MASHIE Public API Documentation (v2)
                </h1>
                <h3 className={styles.whiteText}>
                    Manage your MASHIE experience
                </h3>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v2' />
                <SectionDropdown page='index' />

                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to fully manage your members'
                            access to the MASHIE app, including: creating
                            members, updating member information, renewing
                            memberships, deleting members, and releasing members
                            back to MASHIE.
                        </p>

                        <div className={styles.spacer} />

                        <h2>Major updates since v1</h2>
                        <p>
                            <strong>NAMING CHANGES</strong> - All references to
                            user have been replaced with member.
                        </p>
                        <br />
                        <p>
                            <strong>DOCUMENTATION</strong> - The documentation
                            is now significiantly more thorough with every
                            response being documented as well as every response
                            being explained in detail.
                        </p>

                        <div className={styles.spacer} />

                        <h2>Getting access</h2>
                        <p>
                            Please speak to your MASHIE rep to obtain access to
                            this API.
                        </p>

                        <div className={styles.spacer} />

                        <h2>Authorisation</h2>
                        <p>
                            This API uses the Bearer Authentication scheme to
                            control access to resources. All requests must
                            provide a token within the authorisation header,
                            like so:
                            <pre className={styles.code}>
                                {"Authorization: Bearer <token>"}
                            </pre>
                            You can obtain your token by contacting your MASHIE
                            rep.
                        </p>

                        <div className={styles.spacer} />

                        <h2>Data formats</h2>
                        <p>
                            This is a JSON API. For endpoints which allow
                            request bodies, please send your data as raw JSON
                            text. All responses will also be in the JSON format.
                            Be sure to set the following header on all requests:
                        </p>
                        <pre className={styles.code}>
                            {"Content-Type: application/json"}
                        </pre>

                        <div className={styles.spacer} />

                        <h2>Endpoints</h2>
                        <p>
                            Please use the following base URL (BASE_API_URL) for
                            all API requests:
                        </p>
                        <pre className={styles.code}>
                            https://api.mashie.club/api/v2/public
                        </pre>
                        <p>
                            Please use the following base URL (BASE_IMAGE_URL)
                            for all image requests:
                        </p>
                        <pre className={styles.code}>
                            https://control.mashie.club/
                        </pre>

                        <div className={styles.spacer} />

                        <h2>API Sections</h2>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/v2/clubs'>
                                <h3>Golf Clubs Documentation (v2)</h3>
                            </Link>
                        </p>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/v2/courses'>
                                <h3>Golf Courses Documentation (v2)</h3>
                            </Link>
                        </p>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/v2/teetimes'>
                                <h3>Tee Times Documentation (v2)</h3>
                            </Link>
                        </p>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/v2/members'>
                                <h3>Members Documentation (v2)</h3>
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v2' />
        </div>
    );
}
